import React, { useCallback } from 'react'
import _ from 'lodash'

import S from './styled'
import {
  Status,
  ImageUpload,
  History,
  Tags,
  Switch,
  TranslatedTextArea,
  GroupToggle,
  TranslatedInput,
  Input,
  Button,
} from  '../../../components'
import required from '../../../common/validators/required'
import { recipeStatuses, recipeDifficulties, servings, requiredByStatus }  from '../../../common/recipe'

const textAreaStyle = { paddingBottom: 0, flex: '1 1', paddingRight: '20px' }

const isRequired = (field, status) => requiredByStatus[status] ? requiredByStatus[status].includes(field) : true

const Recipe = props => {

  const {
    tags,
    locales,
    role,
    defaultLocale,
    regions,
    locked,
    handleLockUnlock,
    isNew,
    unlockDisabled,
    lockRealStatus,
  } = props

  const { text, model, image, list, onChange } = props.model

  const handleTranslationChange = useCallback((field, translates) => {
    onChange({
      target: {
        value: translates,
        name: field,
      },
    })
  }, [onChange])

  const status = model.values.status

  return (
    <S.Recipe>
      <S.RecipeInfo>
        <S.RecipeDetails>
          <S.Inputs>
            <S.InputBlock>
              <Input {...{
                name: 'values.name',
                text,
                title: 'Unique Recipe Name',
                validate: required,
                autoFocus: true,
                disabled: locked,
              }}
              />
              <TranslatedInput {...{
                name: `values.title.${defaultLocale}`,
                text,
                title: 'Recipe Title',
                validate: isRequired('title', status) ? required : null,
                locales,
                defaultLocale,
                translatedField: 'values.title',
                translates: _.get(model, 'values.title'),
                onTranslationChange: handleTranslationChange,
                disabled: locked,
              }}
              />
            </S.InputBlock>
            <S.InputBlock>
              <S.ButtonsBlock>
                <History />
                <Status
                  title="Recipe Status"
                  {...text({
                    name: 'values.status',
                  })}
                  statuses={recipeStatuses}
                  role={role}
                  disabled={locked}
                />
              </S.ButtonsBlock>
              <S.ButtonsBlock>
                <Button onClick={handleLockUnlock} red={!lockRealStatus} disabled={isNew || unlockDisabled}>{
                  lockRealStatus ? 'Unlock' : 'Lock'
                }</Button>
              </S.ButtonsBlock>
            </S.InputBlock>
          </S.Inputs>
          <S.DescriptionBlock>
            <TranslatedTextArea {...{
              name: `values.description.${defaultLocale}`,
              text,
              title: 'Description Text',
              rows: 10,
              style: textAreaStyle,
              validate: isRequired('description', status) ? required : null,
              locales,
              defaultLocale,
              translatedField: 'values.description',
              translates: _.get(model, 'values.description'),
              onTranslationChange: handleTranslationChange,
              withLibrary: true,
              disabled: locked,
            }}
            />
            <GroupToggle {...list({
              name: 'values.servings',
              values: servings,
              validate: isRequired('servings', status) ? required : null,
              disabled: locked,
            })}
            title="Servings"
            />
          </S.DescriptionBlock>
        </S.RecipeDetails>
        <S.RecipeImage>
          <ImageUpload
            {...image({
              name: 'values.image',
              title: 'Recipe Main Image',
              validate: isRequired('image', status) ? required : null,
            })}
            width="360" height="370"
            mobileWidth="185" mobileHeight="185"
            readOnly={locked}
          />
        </S.RecipeImage>
      </S.RecipeInfo>
      <S.Tags>
        <Tags {...list({
          title: 'Local Availability',
          name: 'values.availableRegions',
          values: regions || [],
          disabled: locked,
        })}
        />
      </S.Tags>
      <S.Tags>
        <Tags {...list({
          title: 'Recipe Tags',
          name: 'values.tagIds',
          values: tags || [],
          disabled: locked,
        })}
        />
      </S.Tags>
      <S.Tags>
        <Switch {...text({
          name: 'values.difficulty',
          values: recipeDifficulties,
          disabled: locked,
        })}
        title="Difficulty"
        />
      </S.Tags>
    </S.Recipe>
  )
}

export default Recipe
